import { Grid } from '@mui/material';
import { useBooleanFlagValue } from '@openfeature/react-sdk';

import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import { AlertActions } from 'app/containers/Dashboard/Alert/slice';
import Leihbar from 'assets/leihBar_Logo.svg';
import { translations } from 'locales/i18n';
import { FEATURE_FLAGS } from 'utils/featureFlags';
import usePageHeading from 'utils/hooks/usePageHeading';

export const Statistics = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const isLeihbarStatisticsEnabled = useBooleanFlagValue(
    FEATURE_FLAGS.LEIHBAR.STATISTICS_ENABLED,
    true
  );

  usePageHeading({
    heading: t(translations.pages.leihbar.statistics.title()),
    headingLogo: Leihbar
  });

  useLayoutEffect(() => {
    if (!isLeihbarStatisticsEnabled) {
      navigate('/leihbar');
      dispatch(AlertActions.warning(t(translations.common.areaCurrentlyDisabled())));
    }
  }, [dispatch, isLeihbarStatisticsEnabled, navigate, t]);

  return (
    <Grid container>
      <iframe
        style={{ width: '100%', height: '85vh' }}
        title="iframe"
        src={import.meta.env.VITE_LEIHBAR_STATISTICS_URL}
      />
    </Grid>
  );
};
